import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EMPTY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {FiblTeamsContent} from './FiblTeamsContent';
import reportPayload from './reportPayload';

export const FiblTeamsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'FIBL Teams')}
      description={tt(
        'description',
        'These Coaches have either qualified as FIBL or have a FIBL in their downline.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={FiblTeamsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.fiblTeamsReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EMPTY,
    popoverContentProps: {},
  }),
)(FiblTeamsReport);
